// extracted by mini-css-extract-plugin
module.exports = {"tipText":"style_tipText__2ajHi"};